import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { createDashboardT, getDashboardPlanLabel } from '../i18n/dashboard';
import QuickCreditTopUp from './QuickCreditTopUp.jsx';

function UserAvatar({ user, className, placeholderClassName }) {
  const [failed, setFailed] = useState(false);
  const picture = user?.picture?.trim();

  if (!picture || failed) {
    return <div className={placeholderClassName}>{user?.name?.[0] || '?'}</div>;
  }

  return (
    <img
      className={className}
      src={picture}
      alt=""
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
}

const styles = `
.topnav-premium-menu{
  position:absolute;
  top:52px;
  right:0;
  min-width:280px;
  background:
    radial-gradient(circle at top right, rgba(217,119,6,.10), transparent 34%),
    linear-gradient(180deg, rgba(255,255,255,.96), rgba(248,250,252,.94));
  backdrop-filter:blur(16px);
  border-radius:20px;
  box-shadow:0 24px 54px rgba(15,23,42,.18);
  border:1px solid rgba(226,232,240,.85);
  z-index:200;
  overflow:hidden;
  direction:rtl;
  font-family:"Cairo","IBM Plex Sans Arabic","Inter","SF Pro Display",ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  transform-origin:top right;
  padding:10px;
  animation:topnavMenuFade .2s ease;
}
.topnav-premium-section{
  padding:12px;
}
.topnav-premium-identity{
  display:flex;
  align-items:center;
  gap:12px;
}
.topnav-premium-avatar,
.topnav-premium-avatar-placeholder{
  width:44px;
  height:44px;
  border-radius:50%;
  flex:0 0 auto;
  border:2px solid rgba(255,255,255,.72);
  box-shadow:0 0 0 4px rgba(217,119,6,.08);
}
.topnav-premium-avatar{
  object-fit:cover;
}
.topnav-premium-avatar-placeholder{
  display:flex;
  align-items:center;
  justify-content:center;
  background:linear-gradient(135deg, rgba(217,119,6,.95), rgba(99,102,241,.9));
  color:#fff;
  font-size:14px;
  font-weight:900;
}
.topnav-premium-identity-copy{
  min-width:0;
}
.topnav-premium-name{
  font-size:15px;
  font-weight:900;
  color:#0f172a;
}
.topnav-premium-email{
  font-size:12px;
  color:#64748b;
  margin-top:4px;
  direction:ltr;
  text-align:right;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.topnav-premium-status{
  margin-top:6px;
  padding:14px;
  border-radius:16px;
  background:
    linear-gradient(180deg, rgba(15,23,42,.03), rgba(255,255,255,.7)),
    linear-gradient(135deg, rgba(217,119,6,.08), rgba(99,102,241,.06));
  border:1px solid rgba(226,232,240,.9);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.7);
}
.topnav-premium-status-label{
  font-size:10px;
  letter-spacing:.14em;
  text-transform:uppercase;
  color:#94a3b8;
  font-weight:800;
}
.topnav-premium-status-row{
  margin-top:10px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
}
.topnav-premium-badges{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
}
.topnav-premium-badge{
  border-radius:999px;
  padding:6px 10px;
  font-size:11px;
  font-weight:800;
  border:1px solid rgba(226,232,240,.9);
  background:#f8fafc;
  color:#334155;
}
.topnav-premium-badge.accent{
  background:rgba(217,119,6,.10);
  border-color:rgba(217,119,6,.18);
  color:#b45309;
}
.topnav-premium-credits{
  display:flex;
  align-items:center;
  gap:8px;
  color:#0f172a;
  font-weight:900;
  font-size:15px;
}
.topnav-premium-credits span{
  font-size:12px;
  color:#64748b;
  font-weight:700;
}
.topnav-credit-pill{
  display:flex;
  align-items:center;
  gap:12px;
  padding:8px 10px 8px 14px;
  border-radius:18px;
  border:1px solid rgba(217,119,6,.14);
  background:
    radial-gradient(circle at top right, rgba(245,158,11,.12), transparent 42%),
    linear-gradient(180deg, rgba(255,255,255,.98), rgba(255,250,240,.96));
  box-shadow:0 14px 28px rgba(217,119,6,.08);
  color:#0f172a;
  white-space:nowrap;
}
.topnav-credit-summary{
  display:grid;
  gap:2px;
}
.topnav-credit-label{
  font-size:10px;
  color:#b45309;
  font-weight:800;
  letter-spacing:.08em;
  text-transform:uppercase;
}
.topnav-credit-pill strong{
  font-size:18px;
  font-weight:900;
  line-height:1;
}
.topnav-credit-pill span{
  font-size:12px;
  color:#475569;
  font-weight:700;
}
.topnav-premium-actions{
  display:grid;
  gap:6px;
  padding:4px 0 0;
}
.topnav-premium-item{
  width:100%;
  padding:12px 14px;
  text-align:right;
  background:none;
  border:none;
  cursor:pointer;
  font-family:"Cairo","IBM Plex Sans Arabic","Inter","SF Pro Display",ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  font-size:14px;
  color:#0f172a;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  border-radius:14px;
  transition:background .18s ease, transform .18s ease, color .18s ease, box-shadow .18s ease;
}
.topnav-premium-item:hover{
  background:#f8fafc;
  transform:translateX(-2px);
  box-shadow:0 10px 18px rgba(15,23,42,.06);
}
.topnav-premium-item:active{
  transform:scale(.985);
}
.topnav-premium-item-main{
  display:flex;
  align-items:center;
  gap:10px;
}
.topnav-premium-item-icon{
  width:32px;
  height:32px;
  border-radius:10px;
  display:flex;
  align-items:center;
  justify-content:center;
  background:rgba(15,23,42,.05);
  color:#475569;
  transition:all .18s ease;
}
.topnav-premium-item:hover .topnav-premium-item-icon{
  background:rgba(217,119,6,.10);
  color:#b45309;
}
.topnav-premium-item-arrow{
  color:#94a3b8;
  font-size:12px;
}
.topnav-premium-item.danger{
  color:#dc2626;
}
.topnav-premium-item.danger .topnav-premium-item-icon{
  background:rgba(220,38,38,.08);
  color:#dc2626;
}
.topnav-premium-item.danger:hover{
  background:rgba(254,242,242,.9);
}
.topnav-premium-item.disabled{
  opacity:.72;
  cursor:default;
}
.topnav-premium-item.disabled:hover{
  transform:none;
  background:rgba(248,250,252,.72);
  box-shadow:none;
}
.topnav-premium-soon{
  display:inline-flex;
  align-items:center;
  padding:4px 8px;
  border-radius:999px;
  background:rgba(15,23,42,.06);
  color:#64748b;
  font-size:10px;
  font-weight:800;
}
.topnav-premium-caret{
  color:rgba(255,255,255,.52);
  font-size:10px;
  margin-right:2px;
  transition:transform .18s ease;
}
.topnav-user-open .topnav-premium-caret{
  transform:rotate(180deg);
}
@keyframes topnavMenuFade{
  from{opacity:0;transform:translateY(-6px) scale(.98)}
  to{opacity:1;transform:translateY(0) scale(1)}
}
`;

export default function TopNav({ backTo, backLabel, actions, leadingAction, title, containerWidth = '1440px' }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef(null);
  const t = createDashboardT('ar');

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };
  const pricingPath = `/pricing?return_to=${encodeURIComponent(`${location.pathname}${location.search}`)}`;

  return (
    <nav className={`topnav${scrolled ? ' scrolled' : ''}`}>
      <style>{styles}</style>
      <div className="topnav-inner" style={{ maxWidth: containerWidth }}>
        <div className="topnav-left">
          {backTo && (
            <button className="bbt" onClick={() => navigate(backTo)}>
              ← {backLabel || t('back')}
            </button>
          )}
          {leadingAction}
          {title && (
            <div className="topnav-page-title" style={{ marginLeft: backTo ? 6 : 0 }}>
              {title}
            </div>
          )}
        </div>
        <div className="topnav-spacer" />
        <div className="topnav-right">
          {actions}
          {user && (
            <>
              <div className="topnav-credit-pill" title="Available AI credits">
                <div className="topnav-credit-summary">
                  <div className="topnav-credit-label">AI Wallet</div>
                  <strong>{user.ai_credits ?? 0}</strong>
                </div>
                <span>الرصيد المتبقي</span>
                <QuickCreditTopUp returnTo={`${location.pathname}${location.search}`} />
              </div>
            </>
          )}
          {user && (
            <div ref={menuRef} style={{ position: 'relative' }} className={menuOpen ? 'topnav-user-open' : ''}>
              <div className="user-pill" onClick={() => setMenuOpen(!menuOpen)} style={{ transition: 'transform .18s ease, box-shadow .18s ease, background .18s ease', cursor: 'pointer' }}>
                <UserAvatar user={user} className="user-avatar" placeholderClassName="user-avatar-placeholder" />
              </div>
              {menuOpen && (
                <div className="topnav-premium-menu">
                  <div className="topnav-premium-section">
                    <div className="topnav-premium-identity">
                      <UserAvatar user={user} className="topnav-premium-avatar" placeholderClassName="topnav-premium-avatar-placeholder" />
                      <div className="topnav-premium-identity-copy">
                        <div className="topnav-premium-name">{user.name}</div>
                        <div className="topnav-premium-email">{user.email}</div>
                      </div>
                    </div>
                    <div className="topnav-premium-status">
                      <div className="topnav-premium-status-label">{t('accountStatus')}</div>
                      <div className="topnav-premium-status-row">
                        <div className="topnav-premium-badges">
                          <span className="topnav-premium-badge accent">
                            {getDashboardPlanLabel(user.plan, t)}
                          </span>
                        </div>
                        <div className="topnav-premium-credits">
                          <strong>{t('credits', { count: user.ai_credits ?? 0 })}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="topnav-premium-section">
                    <div className="topnav-premium-actions">
                    {user?.is_admin && (
                      <button onClick={() => { navigate('/admin'); setMenuOpen(false); }} className="topnav-premium-item">
                        <div className="topnav-premium-item-main">
                          <span className="topnav-premium-item-icon">⚙</span>
                          <span>{t('adminPanel')}</span>
                        </div>
                        <span className="topnav-premium-item-arrow">‹</span>
                      </button>
                    )}
                      <button onClick={() => { navigate('/results'); setMenuOpen(false); }} className="topnav-premium-item">
                        <div className="topnav-premium-item-main">
                          <span className="topnav-premium-item-icon">▣</span>
                          <span>{t('results')}</span>
                        </div>
                        <span className="topnav-premium-item-arrow">‹</span>
                      </button>
                      <button onClick={() => { navigate('/credit-history'); setMenuOpen(false); }} className="topnav-premium-item">
                        <div className="topnav-premium-item-main">
                          <span className="topnav-premium-item-icon">◎</span>
                          <span>سجل الرصيد</span>
                        </div>
                        <span className="topnav-premium-item-arrow">‹</span>
                      </button>
                      <button className="topnav-premium-item disabled" type="button">
                        <div className="topnav-premium-item-main">
                          <span className="topnav-premium-item-icon">⚙</span>
                          <span>{t('accountSettings')}</span>
                        </div>
                        <span className="topnav-premium-soon">{t('settingsSoon')}</span>
                      </button>
                      <button onClick={() => { navigate(pricingPath); setMenuOpen(false); }} className="topnav-premium-item">
                        <div className="topnav-premium-item-main">
                          <span className="topnav-premium-item-icon">💳</span>
                          <span>{t('billingAndPlan')}</span>
                        </div>
                        <span className="topnav-premium-item-arrow">‹</span>
                      </button>
                      <button onClick={handleLogout} className="topnav-premium-item danger">
                        <div className="topnav-premium-item-main">
                          <span className="topnav-premium-item-icon">↩</span>
                          <span>{t('logout')}</span>
                        </div>
                        <span className="topnav-premium-item-arrow">‹</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
